import { createSlice } from '@reduxjs/toolkit';
export const view = createSlice({
  name: 'view',
  initialState: {
    isMobile: false,
    isTablet: false,
    planListActiveLink: null,
    searchBoxCollapseExpanded: true,
    isPlanListPage: false,
    home: '/',
    generalConditions: false,
    mobileMenuDrawer: false,
    mobileMenuProfileDrawer: false

  },
  reducers: {
    IS_MOBILE: (state, action) => {

      return {
        ...state,
        isMobile: action.payload,
        // grid: action.payload ? 'col' : 'row',
      };
    },
    IS_TABLET: (state, action) => {

      return {
        ...state,
        isTablet: action.payload
      };
    },
    TOGGLE_MOBILE_MENU_DRAWER: (state, action) => {
      return {
        ...state,
        mobileMenuDrawer: action.payload
      }
    },

    TOGGLE_MOBILE_MENU_PROFILE_DRAWER: (state, action) => {
      return {
        ...state,
        mobileMenuProfileDrawer: action.payload
      }
    }

    // export const toggleMobileMenuDrawer = (value) => {
    //   return {
    //     type: TOGGLE_MOBILE_MENU_DRAWER,
    //     value,
    //   };
    // };


    // export const toggleMobileMenuProfileDrawer = (value) => {
    //   return {
    //     type: TOGGLE_MOBILE_MENU_PROFILE_DRAWER,
    //     value,
    //   };
    // };


  },
});
export const { IS_MOBILE,
  IS_TABLET,
  TOGGLE_MOBILE_MENU_DRAWER,
  TOGGLE_MOBILE_MENU_PROFILE_DRAWER } = view.actions;
export default view.reducer;